module.exports = __webpack_public_path__ + "static/media/lep_sound_3.0a7521de.wav";


//////////////////
// WEBPACK FOOTER
// ./src/components/containers/play-screen/easter-eggs/saint_patricks_day/lep_sounds/lep_sound_3.wav
// module id = 447
// module chunks = 0